import {
	FormControl,
	FormHelperText,
	Heading,
	HStack,
	Spinner,
	Stack,
	Text,
	VStack,
	Box,
	Link,
	Icon,
	Image,
} from '@chakra-ui/react'
import { startsWith } from 'lodash'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { useSendCognitoOtp } from '../../../hooks/login.hooks'
import { AUTH_LOGIN_MODE } from '../../../utils/constant'
import { AiOutlineWindows } from 'react-icons/ai'
import { LOGIN_MODE, LS_LOGIN_MODE } from '../login.util'
import { FORM_VIEW } from './otp.config'
import { TfiEmail } from 'react-icons/tfi'
import greneLogo from '../../../assets/images/grene-logo.png'
import ButtonCTA from './../../globalComponents/button/index'
import SVGIcon from '../../../assets/svgIcons'

export default function PhoneNumberInput({ onSendOtpSuccess, setLoginMode }) {
	const {
		handleSubmit,
		formState: { errors },
		control,
		useFormMethods,
	} = useForm()
	const { mutate, isLoading, isError } = useSendCognitoOtp()

	const onSave = data => {
		const {
			phone_number: { fv, v },
		} = data
		let splitPhone = fv.split(' ')
		let country = splitPhone[0]
		let phone = v.replace(parseInt(country), '')
		mutate(
			{
				countryCode: country,
				mobile: phone,
			},
			{
				onSuccess: async data => {
					sessionStorage.setItem(AUTH_LOGIN_MODE, LS_LOGIN_MODE.OTP)
					onSendOtpSuccess(data, FORM_VIEW.OTP_VIEW, { country, phone })
				},
				onError: err => {
					console.log('error', err)
				},
			}
		)
	}
	let validPhoneNumber = false
	const validatePhoneNumber = (inputNumber, country, isDirty, phoneLength) => {
		
		if (isDirty) {
			let inputPhone = inputNumber?.replace(country.dialCode, '')?.trim()
			if(+country.dialCode === 880 || +country.dialCode === 49){
				phoneLength=10
			}
			if(+country.dialCode === 961){
				phoneLength=8
			}
			if(+country.dialCode === 421){
				phoneLength=9
			}
			if (inputNumber && inputPhone === '') {
				validPhoneNumber = false
				return false
			} else if (+country.dialCode === 61) {
				if (inputPhone.length === 9 || inputPhone.length === 10) {
					if (inputPhone.length === 9) {
						if (inputPhone.toString().startsWith('0')) {
							validPhoneNumber = false
							return false
						} else {
							validPhoneNumber = true
							return true
						}
					} else {
						if (inputPhone.toString().startsWith('0')) {
							validPhoneNumber = true
							return true
						} else {
							validPhoneNumber = false
							return false
						}
					}
				} else {
					validPhoneNumber = false
					return false
				}
			} else if (inputPhone.length < phoneLength) {
				validPhoneNumber = false
				return false
			}
			validPhoneNumber = true
			return true
		}
		validPhoneNumber = false
		return false
	}
	return (
		<>
			<Heading fontWeight='900' fontSize='1.625rem' lineHeight='2.25rem'>
				Login Using Phone
			</Heading>
			<Text fontWeight='500' fontSize='1rem' lineHeight='1.375rem'>
				Login using your phone number
			</Text>

			<form onSubmit={handleSubmit(onSave)}>
				<VStack minH='5rem' spacing={8} justifyContent='center'>
					<FormControl id='phonenumber' pt={2}>
						<Controller
							//rules={{ required: true }}
							rules={{
								required: true,
								validate: () => validPhoneNumber || 'error',
							}}
							render={props => (
								<PhoneInput
									onChange={(v, c, e, fv) => {
										props.field.onChange({ v, fv })
									}}
									// //onBlur={onBlur}
									country={'in'}
									onlyCountries={[
										'au',
										'in',
										'us',
										'bd',
										'gb',
										'de',
										'fr',
										'lb',
										'hk',
										'sk',
									]}
									countryCodeEditable={false}
									name='phone_number'
									enableSearch
									buttonStyle={{ border: 'none' }}
									buttonClass='rounded '
									inputStyle={{
										maxWidth: '260px',
										margin: 'auto',
										border: 'none',
										fontSize: '1.125rem',
										fontFamily: 'Avenir',
										backgroundColor: 'white',
									}}
									containerStyle={{
										borderBottom: '1px solid #D9D9D9',
										padding: '2px',
										fontFamily: 'Avenir',
									}}
									//value={props.field.value}
									isValid={(inputNumber, country, countries) => {
										const originalPhoneNumber = countries.filter(
											val => val.dialCode === country.dialCode
										)[0]?.format
										const phoneNumberWithoutSpecialChars =
											originalPhoneNumber?.replace(/[+() -]/g, '').length
										const phoneLength =
											phoneNumberWithoutSpecialChars - country.dialCode.length
										return validatePhoneNumber(
											inputNumber,
											country,
											props.formState.isDirty,
											phoneLength
										)
									}}
								/>
							)}
							disabled={isLoading}
							name='phone_number'
							control={control}
							defaultValue=''
						/>

						{errors && errors['phone_number'] && (
							<FormHelperText color='red.600' fontWeight='400' fontSize='sm'>
								Please provide valid mobile number
							</FormHelperText>
						)}
					</FormControl>
					<HStack alignItems='center'>
						<ButtonCTA
							type='submit'
							bg='brand.800'
							color='#828282'
							size='md'
							minW='320px'
							borderRadius='22px'
							background='gray.600'
							border='1px solid #D9D9D9'
							_hover={{
								color: 'white',
								background:
									'linear-gradient(268.34deg, #139988 10.16%, #008A4B 102.89%)',
							}}
							fontWeight='900'
							fontSize='1rem'
							lineHeight='1.375rem'
							disabled={!!isLoading}
						>
							SEND OTP
						</ButtonCTA>
					</HStack>
					{isError && (
						<Text color='red.600' fontWeight='400' fontSize='sm'>
							No user found!
						</Text>
					)}
					{isLoading ? (
						<Stack
							my={4}
							justifyContent='center'
							alignItems='center'
							direction='column'
						>
							<Spinner size='lg' />
							<Text color='brand.800'>Please, wait...</Text>
						</Stack>
					) : null}
				</VStack>
			</form>
			<Box>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.QR)
					}}
				>
					{/* <Image src={greneLogo} maxW='1.375rem' mr={4} /> */}
					<Box mr={4}>
						<SVGIcon
							iconName='greenlogoSvg'
							svgProps={{
								width: '20',
								height: '19',
								viewBox: '0 0 20 19',
							}}
							pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					Login using GRID App
				</Link>
				<Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.EMAIL)
					}}
				>
					<Icon as={TfiEmail} mr={4} w='1.375rem' h='1.375rem' />
					Login using Email
				</Link>
				{/* <Link
					fontSize='0.875rem'
					variant='string'
					lineHeight='2.25rem'
					fontWeight='900'
					color='brand.700'
					display='flex'
					alignItems='center'
					onClick={() => {
						setLoginMode(LOGIN_MODE.ACTIVE_DIRECTORY)
					}}
				>
					<Icon as={AiOutlineWindows} mr={4} w='1.375rem' h='1.375rem' />
					Login using Active Directory
				</Link> */}
			</Box>
		</>
	)
}
